import { combineReducers } from 'redux'
import PredefinedEventManagementPredefinedEventListSlice from '../../slices/experiences/PredefinedEventManagementPredefinedEventListSlice'

const PredefinedEventManagementExperienceStore = combineReducers({
  list: PredefinedEventManagementPredefinedEventListSlice.reducer
})

export default PredefinedEventManagementExperienceStore
